import type { SandboxComponentPreset } from '../../sandboxPresetTypes'
import accordionOne from './accordion-one'
import busyOverlay from './busy-overlay'
import counter from './counter'
import emailRegex from './email-regex'
import kanbanLite from './kanban-lite'
import listHover from './list-hover'
import passwordStrength from './password-strength'
import progressBarStrip from './progress-bar-strip'
import progressRingSvg from './progress-ring-svg'
import reorderCards from './reorder-cards'
import skeletonShimmer from './skeleton-shimmer'
import sortableTable from './sortable-table'
import spinnerDots from './spinner-dots'
import spinnerRing from './spinner-ring'
import splitPane from './split-pane'
import starter from './starter'
import svgMenuMorph from './svg-menu-morph'
import svgSparkline from './svg-sparkline'
import svgStrokeDraw from './svg-stroke-draw'
import tabsKeyboard from './tabs-keyboard'
import tagInput from './tag-input'
import toastStack from './toast-stack'
import toggle from './toggle'
import validationEmailFlow from './validation-email-flow'

/**
 * Single assembly point for PR-sized preset modules.
 * Order: core basics, then wave demos (loading → SVG → DnD → forms → feedback → table → tabs). Keep
 * this order in sync with the product/library UX.
 */
export const SANDBOX_PRESET_DEFINITIONS: SandboxComponentPreset[] = [
  starter,
  counter,
  emailRegex,
  toggle,
  listHover,
  progressBarStrip,
  progressRingSvg,
  spinnerRing,
  spinnerDots,
  skeletonShimmer,
  busyOverlay,
  svgStrokeDraw,
  svgSparkline,
  svgMenuMorph,
  reorderCards,
  kanbanLite,
  splitPane,
  validationEmailFlow,
  passwordStrength,
  tagInput,
  toastStack,
  accordionOne,
  sortableTable,
  tabsKeyboard,
]
